module.exports = __webpack_public_path__ + "static/img/relief03.e5d4a3a.bmp";


//////////////////
// WEBPACK FOOTER
// ./src/views/papercutLamp/imgs/relief03.bmp
// module id = y8XI
// module chunks = 2